<template>
    <div id="marcarOutras" style="margin:0px;padding:0px;overflow:hidden">

        <iframe 
            v-if="link"
            :src="link" 
            title="Marcações"
            frameborder="0"
            style="overflow:hidden;width:100%;height: calc(100vh - 195px);"
        >
        </iframe>
        
    </div>
</template>

<script>

    export default {
        name: 'Scheduler',
        props: [
        'hotelSelected',
        ],
        data: function() {
            return {
                link: null,
            }
        }, 
        components: {

        },
        methods: {
            iframeLink(hotel_id){
                let base_url = '';
                if(process.env.NODE_ENV == 'production'){
                    base_url = 'https://my.vilagale.com/';
                }else if(process.env.NODE_ENV == 'quality'){
                    base_url = 'http://192.168.200.20:8383/#/';
                }else if(process.env.NODE_ENV == 'development'){
                    base_url = 'http://localhost:8383/';
                }
                if(base_url != ''){
                    this.link = base_url+'internal/my_bookings/'+hotel_id+'/3/'+this.token;
                }else{
                    this.notify('Problemas com o link (NODE_ENV)', 'red');
                }
                
            }
        }, 
        mounted: function() { 

        } ,   
        created() {
            this.token = window.localStorage.getItem('usertoken');
            if(this.hotelSelected){
                this.iframeLink(this.hotelSelected);
            }
        }, 
        computed: {

        },
        watch: {
            hotelSelected: function(new_val, old_val) {
                this.iframeLink(new_val);
                
            },
        },
    }
</script>
